import { Typography } from '@euler/app/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { CoachingProfileCase } from '@euler/model/coaching-progress';
import { memo } from 'react';
import { View } from 'react-native';
import { aiColors } from '../../../ai-suite/theme';
import { Chip } from '../../components/Chip';
import { levelColor, levelName } from '../../copy';

/** Each case practised, with the best stars at each level. */
export const CaseStarsList = memo(
  ({ cases }: { cases: CoachingProfileCase[] }) => {
    const { rpx } = useResponsiveContext();
    const byCase = new Map<string, CoachingProfileCase[]>();
    for (const x of cases)
      byCase.set(x.caseId, [...(byCase.get(x.caseId) ?? []), x]);
    return (
      <View style={{ gap: rpx(12) }}>
        {[...byCase.values()].map(levels => (
          <View key={levels[0].caseId} style={{ gap: rpx(6) }}>
            <Typography.Text size={rpx(14)} color={aiColors.foreground}>
              {levels[0].title}
            </Typography.Text>
            <View
              style={{ flexDirection: 'row', flexWrap: 'wrap', gap: rpx(8) }}
            >
              {[...levels]
                .sort((a, b) => a.difficulty - b.difficulty)
                .map(x => (
                  <View
                    key={x.difficulty}
                    style={{
                      flexDirection: 'row',
                      alignItems: 'center',
                      gap: rpx(4),
                    }}
                  >
                    <Chip
                      text={levelName(x.difficulty)}
                      color={levelColor(x.difficulty)}
                    />
                    <Typography.Text size={rpx(12)} color={aiColors.amber}>
                      {'★'.repeat(x.bestStars) + '☆'.repeat(3 - x.bestStars)}
                    </Typography.Text>
                  </View>
                ))}
            </View>
          </View>
        ))}
      </View>
    );
  },
);
